import {
    NewsListResolver,
    NewsEditResolver,
    AdminNewsListResolver
} from './services/news.resolver.service';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewsListComponent } from './components/NewsList.component';
import { CreateNewsComponent } from './components/CreateNews.component';
import { NewsComponent } from './news.component';
import { 
    ConfirmationService,
     SharedModule } from 'primeng/api';
import { NewsServices } from './services/news.service';
import { AppSharedModule } from './../shared/appShared.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({ declarations: [
        NewsComponent,
        NewsListComponent,
        CreateNewsComponent
    ],
    bootstrap: [NewsListComponent, CreateNewsComponent, NewsComponent],
    imports: [
        BrowserModule,
        RouterModule,
        SharedModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ReactiveFormsModule,
        ContextMenuModule,
        MenuModule,
        ConfirmDialogModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule
    ],
    providers: [
        NewsServices,
        ConfirmationService,
        NewsListResolver,
        NewsEditResolver,
        AdminNewsListResolver,
        provideHttpClient(withInterceptorsFromDi())]
})
export class NewsModule {}
